/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API48133Item {
  
  /** 主键Id */
  id?: number;
  
  /** 企划书编号 */
  planNo?: string;
  
  /** 企划书名称 */
  planName?: string;
  
  /** 可行性分析结果 */
  feasibilityAnalysis?: string;
  
  /** 企划书状态 */
  planStatus?: number;
  
  /** 创建人 ,StaffResp */
  creator?: any;
  
  /** 创建时间 */
  createdDate?: any;
  
  /** 审核人 ,StaffResp */
  auditor?: any;
  
  /** 审核时间 */
  auditDate?: any;
  
  /** 操作权限对象 ,BizPlanAuthorizationResp */
  authorization?: any;
  
  /** 关联项目No */
  projectNo?: string;
  
};
    
  



export interface API48133Req {
  
  /** 企划书名称模糊 */
  planName: string;
  /** 项目状态 */
  planStatus: string;
  /**  */
  pageSize: string;
  /**  */
  pageIndex: string;
  /**  */
  rowId: string;
  /**  */
  jumpType: string;
  /**  */
  searchCount: string;
  /**  */
  orderObjects: string;
  /** 企划书名称模糊 */
  planName?: string;
  /** 项目状态 */
  planStatus?: number;
  /**  */
  pageSize?: number;
  /**  */
  pageIndex?: number;
  /**  */
  rowId?: string;
  /**  */
  jumpType?: number;
  /**  */
  searchCount?: boolean;
  /** OrderByColumn */
  orderObjects?: any[];
};



export interface API48133Res {
  /** T  */
  list?: API48133Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 48133 分页查询商业计划书       -

export interface IUsePostAPI48133Return {
  /** 分页查询商业计划书       -: 接口请求状态 */
  isAPI48133Loading: boolean;
  /** 分页查询商业计划书       -: 接口请求返回数据 */
  dataAPI48133: API48133Res;
  /**  分页查询商业计划书       -: 接口数据请求方法 */
  fetchAPI48133Data:  (inputs: API48133Req, config?: YWRequestConfig) => Promise<API48133Res>;
  /** 分页查询商业计划书       -: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48133 = ():IUsePostAPI48133Return => {
  let isMount = true;
  const [isAPI48133Loading, setIsAPI48133Loading] = useState(false);
  const [dataAPI48133, setDataAPI48133] = useState<API48133Res>({} as API48133Res);
  const requestUrl = `${basePath}/corp-admin/project/plan4biz/page`;

  const fetchAPI48133Data = async (inputs: API48133Req, config?: YWRequestConfig): Promise<API48133Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48133Req>) || {}) as API48133Req;
    
  
    if ( isMount ) {
      setIsAPI48133Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48133Res>(`${basePath}/corp-admin/project/plan4biz/page`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48133(res || {} as API48133Res);
        setIsAPI48133Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48133Loading(false);
      }
      return false as unknown as API48133Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48133Loading,
    dataAPI48133,
    fetchAPI48133Data,
    requestUrl,
  }
}

